import PropTypes from 'prop-types'
import { createContext, useEffect, useState} from "react"
import { getAll } from "../services/admins"

export const DataContext = createContext()

export const DataProvider = ({ children }) => {
  const [admins, setAdmins] = useState([])

  useEffect(() => {      
      read()
  }, [])

  const read = async () =>  {
    getAll()
    .then((res) => {
      setAdmins(res.data)
    })
    .catch((e) => {
      console.error(e)
    })
  }

  const value = {
    admins: [admins]
  }
    
  return(
    <DataContext.Provider value={value}>
        { children }
    </DataContext.Provider>
  )

}

DataProvider.propTypes = {
  children: PropTypes.any
}
